import React from 'react';

/** Danh từ chỉ người đặt cho câu admin ("Doanh nghiệp: …" / "Cá nhân: …"). */
export const ordererNoun = (kind?: string | null): 'Cá nhân' | 'Doanh nghiệp' =>
  kind === 'Individual' ? 'Cá nhân' : 'Doanh nghiệp';

/** Nhãn cạnh tên người đặt ở mọi nơi creator thấy (spec §3). Doanh nghiệp hoặc dữ liệu cũ: không hiện gì. */
export const IndividualOrdererBadge: React.FC<{ kind?: string | null; className?: string }> = ({ kind, className }) =>
  kind === 'Individual' ? (
    <span
      title="Người đặt là cá nhân đã định danh (eKYC) trên Cab"
      className={`inline-flex shrink-0 items-center rounded-full bg-emerald-50 px-2 py-0.5 text-[11px] font-semibold text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-300 ${className ?? ''}`}
    >
      Cá nhân đã định danh
    </span>
  ) : null;

/** Tên người đặt ở trang admin: cá nhân kèm chip "Cá nhân" và họ tên theo CCCD (chỉ admin thấy). */
export const AdminOrdererLabel: React.FC<{ name: string; kind?: string | null; ownerIdentityName?: string | null }> = ({
  name,
  kind,
  ownerIdentityName,
}) => (
  <span className="inline-flex flex-wrap items-center gap-1">
    <span>{name}</span>
    {kind === 'Individual' && (
      <>
        <span className="rounded-full bg-emerald-100 px-1.5 py-0.5 text-[10px] font-semibold text-emerald-700 dark:bg-emerald-900/40 dark:text-emerald-300">
          Cá nhân
        </span>
        {ownerIdentityName && <span className="text-[11px] text-gray-500 dark:text-gray-400">Họ tên theo CCCD: {ownerIdentityName}</span>}
      </>
    )}
  </span>
);
